<template>
	<div v-if="loginModel.openToken == undefined || loginModel.openToken == null || loginModel.openToken == ''">
		<div v-show="showPage">
			<div class="ztitle clearfix1" style="line-height: 47px;">
				<img :src="hostOrg.portalLogo" class="zlogo" style="width: 47px;height:47px;">
				<span style="font-weight: bold;font-size: 25px;">
					{{ hostOrg.portalSysName || '' }}
				</span>
				<div class="ztitr">
					<a :href="portalUrl" target="_blank" class="ztita">管理端</a>
					&nbsp;&nbsp; | &nbsp;&nbsp;
					<el-popover placement="top-start" trigger="hover" width="120" content="">
						<img src="../assets/images/qrcode.jpg" width="120" height="120" />
						<a slot="reference" style="font-size:14px;cursor: pointer;">手机网页</a>
					</el-popover>
				</div>
			</div>
			<div class="zdlbg" @keyup.enter="dologin()">
				<div class="zlbg">
					<h2 class="zh2">用户登录</h2>
					<div class="zcon clearfix1">
						<img src="../assets/images/icon-l2.png" class="zicon">
						<input class="zinput1" id="username" placeholder="请输入用户名" v-model="loginModel.username" />
					</div>
					<div class="zcon clearfix1">
						<img src="../assets/images/icon-l1.png" class="zicon">
						<input class="zinput1" id="password" type="password" placeholder="请输入密码"
							v-model="loginModel.password" />
					</div>
					<div class="zcon1 clearfix1">
						<input class="zinput2" placeholder="请输入右侧验证码" id="yzm_code" v-model="loginModel.code">
						<img id="img_verifycode" src="../assets/images/yzm.png" class="zyzm" @click="reloadImgcode()">
					</div>
					<a href="javascript:void(0);" class="zlogina" @click="dologin">登录</a>
				</div>
			</div>
			<p class="zcopyright">©2019-2020保留所有权利{{ hostOrg.adminSysName }}版权所有</p>
		</div>
	</div>
</template>
<script>
import { getHostOrgSetting, h5Student, mobilelogin } from "@/api/login.js"
import { mapState, mapMutations } from "vuex";
export default {
	name: "Login",
	data: function () {
		return {
			hostOrg: {},
			showPage: false,
			portalUrl: '',
			loginModel: {
				openToken: this.$route.query.openToken,
				username: '',
				password: '',
				code: ''
			},
		}
	},
	computed: {
		...mapState(["isLogin", "user"]),
	},
	created: function () {
		//利用浏览器缓存的Cookie尝试登录
		// if(this.$cookies.get("_xunw_admin_logined") &&
		// 	this.$cookies.get("_xunw_admin_logined") == 1) {
		// 	this.$router.push({path:'/index'});
		// }
		if (this.isLogin && this.user) {
			// this.$router.push({path:'/index'});
			this.toAutoLogin(this.user)
		}
		else {
			//单点登录系统使用openToken自动登录,不显示登录页面
			if (this.loginModel.openToken) {
				this.autoLogin();
			}
			else {//正常流程的登录，此处先预加载主办单位系统名称，图标等信息
				this.loadHostOrgSetting();
			}
		}
	},
	mounted() {

	},
	methods: {
		toAutoLogin(loginInfo) {
			const _this = this
			mobilelogin({
					studentId: loginInfo.userId,
					autoLogin: 1
				}).then((res) => {
					// 缓存登录信息
					this.$store.commit("LOGIN", res);
					this.$store.commit("ISLOGIN", true);
					this.$router.push({path:'/index'});
			})

		},
		dologin: function () {
			if (!this.loginModel.username) {
				this.$message({
                  message: '请输入用户名',
                  type: 'error'
                })
				return false;
			}
			if (!this.loginModel.password) {
				this.$message({
                  message: '请输入密码',
                  type: 'error'
                })
				return false;
			}
			if (!this.loginModel.code) {
				this.$message({
                  message: '请输入验证码',
                  type: 'error'
                })
				return false;
			}
			mobilelogin(this.loginModel).then(res => {
				let data = res || {};
				// let isRawPassword = data.isRawPassword || 0;
				// if (isRawPassword == 1) {
				// 	this.$router.push({ name: "UpdateRawPassword", query: { id: data.id } });
				// }
				// else {
					// this.$cookies.set("_xunw_admin_logined", "1", "0");
					this.$store.commit("LOGIN", data);
					this.$store.commit("ISLOGIN", true);
					this.$router.push({path:'/index'});
				// }
			});
		},
		reloadImgcode: function () {
			let SYSTEM=''
			if(process.env.NODE_ENV=="development"){
				SYSTEM=process.env.VUE_APP_MANAGEMENT_SYSTEM
			}else{
				SYSTEM=location.protocol+'//'+this.hostOrg.portalDomain+process.env.VUE_APP_BASE_URL
			}
			document.getElementById('img_verifycode').src = SYSTEM + "/kaosheng/mobile/imgCode/getValidCode?t=" + Math.random()
		},
		autoLogin: function () {
			h5Student(this.loginModel).then(res => {
				// this.$cookies.set("_xunw_admin_logined", "1", "0");//最后参数'0'表示关闭浏览器的时候销毁cookie
				// 将认证码存入SESSION
				let data = res || {};
				this.$store.commit("LOGIN", data);
				this.$store.commit("ISLOGIN", true);
				this.$router.push({path:'/index'});
			});
		},
		loadHostOrgSetting: function () {
			getHostOrgSetting().then(res => {
				this.hostOrg = res || {};
				this.$store.commit("SYSCONFIG", this.hostOrg);
				document.title = this.hostOrg.portalSysName || '';
				var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				link.rel = 'icon';
				link.href = this.hostOrg.portalLogo && this.hostOrg.portalLogo.replace('http://', 'https://');
				document.getElementsByTagName('head')[0].appendChild(link);
				this.portalUrl = window.location.protocol + '//' + this.hostOrg.adminDomain;
				if (this.hostOrg.id) {
					this.$nextTick(() => {
						this.showPage = true;//显示页面内容
						this.reloadImgcode();//加载请求验证码
					});
				}
			});
		}
	}
}
</script>
<style scoped>
@import "../assets/css/zlogin.css";

.zlogina:hover {
	color: #fff;
	/* background: #ef4748; */

}

.zlogina {
	/* background: #F56C6C; */
}

h2 {
	display: block;
	font-size: 1.5em;
	margin-block-start: 0.83em;
	margin-block-end: 0.83em;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
	font-weight: bold;
}

.ztitr a {
	color: inherit;
	text-decoration: none;
	outline: none;
}

a {
	text-decoration: none;
	outline: none;
}
</style>
